export default __webpack_public_path__ + "static/media/review12.7f86730f.webp";